export enum DragulaGroups {
  KioskProducts = 'kioskProducts',
  KioskProductGroups = 'KioskProductGroups',
  KioskLayout = 'KioskLayout',
  Auditoriums = 'Auditoriums',
  ShapeCreator = 'ShapeCreator',
}
